module.exports = __webpack_public_path__ + "02_glasses_black.cfcef70f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer4/02_glasses_black.png
// module id = eM0c
// module chunks = 0